import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import PrivacyText from "./PrivacyText";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <PrivacyText />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
